var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_243",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.81745 13.545L14.42 7.94245L13.5418 7.06433L8.81745 11.7887L6.44245 9.4137L5.56433 10.2918L8.81745 13.545ZM10.0016 17.9168C8.90662 17.9168 7.87738 17.7091 6.91391 17.2935C5.95044 16.8779 5.11238 16.314 4.39975 15.6016C3.68711 14.8893 3.12287 14.0516 2.70704 13.0885C2.29134 12.1254 2.0835 11.0965 2.0835 10.0016C2.0835 8.90662 2.29127 7.87738 2.70683 6.91391C3.12238 5.95044 3.68634 5.11238 4.3987 4.39975C5.11107 3.68711 5.94877 3.12287 6.91183 2.70704C7.87489 2.29134 8.90384 2.0835 9.9987 2.0835C11.0937 2.0835 12.1229 2.29127 13.0864 2.70683C14.0499 3.12238 14.8879 3.68634 15.6006 4.3987C16.3132 5.11107 16.8775 5.94877 17.2933 6.91183C17.709 7.87489 17.9168 8.90384 17.9168 9.9987C17.9168 11.0937 17.7091 12.1229 17.2935 13.0864C16.8779 14.0499 16.314 14.8879 15.6016 15.6006C14.8893 16.3132 14.0516 16.8775 13.0885 17.2933C12.1254 17.709 11.0965 17.9168 10.0016 17.9168ZM10.0002 16.6668C11.8613 16.6668 13.4377 16.021 14.7293 14.7293C16.021 13.4377 16.6668 11.8613 16.6668 10.0002C16.6668 8.13905 16.021 6.56266 14.7293 5.271C13.4377 3.97933 11.8613 3.3335 10.0002 3.3335C8.13905 3.3335 6.56266 3.97933 5.271 5.271C3.97933 6.56266 3.3335 8.13905 3.3335 10.0002C3.3335 11.8613 3.97933 13.4377 5.271 14.7293C6.56266 16.021 8.13905 16.6668 10.0002 16.6668Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.461534a1d5dd8b9d9b837df838e5fc95.svg";
export { ForwardRef as ReactComponent };